// The ground the Living City built on (components/city/CityPlaces): no car
// parks on the plaza or in the park. Read by game/drive/Vehicles' kerb finder,
// which otherwise reads a tiled square's grout lines as kerbs. Rectangles in
// world units: [minX, maxX, minZ, maxZ], with a margin built in.
export const CITY_NO_PARKING = [
  [78, 114, -40, -6],    // the Plaza and its stage
  [76, 116, 17, 47],     // the Park
];

export function inCityGround(x, z) {
  return CITY_NO_PARKING.some(([x0, x1, z0, z1]) => x >= x0 && x <= x1 && z >= z0 && z <= z1);
}

// THE WELCOME SIGN where visitors arrive (components/WelcomeSign). Its spot lives
// here because the street lamps must keep out of it: lamps are placed
// automatically along every kerb (render/StreetLights), and on 2026-10-23 one
// had landed 1.1 units from the sign, its post straight through the text, and
// the board's right half sat under the HUD map. The sign now stands back on the
// LEFT of the arrival pavement (the road starts at z ≈ 18; the top-left of the
// screen is clear), turned to face where you land, and nothing automatic may
// stand within `clear` of it.
export const WELCOME_SIGN = { x: -3.0, z: 19.6, rotY: 0.49, y: 1.55, scale: 0.85, clear: 2.8 };

/** Spots no automatic street furniture (lamps) may stand in: [x, z, radius]. */
export const KEEP_CLEAR = [
  [WELCOME_SIGN.x, WELCOME_SIGN.z, WELCOME_SIGN.clear],
  // Straight ahead of the arrival point: the first view of the city is down
  // that street, and a lamp pushed out of the sign's way landed right there.
  [0.2, 19.4, 2.6],
];
